import { FormikErrors } from "formik";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { SharedButton } from "@components";
import { IPhone } from "@interfaces";
import { ModulesTelInput } from "@modules";
import { selectMerchant } from "@redux";
import { memo } from "react";

interface IProps {
    values: IPhone;
    errorPhone: string;
    isSubmitting: boolean;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
    setFieldTouched: (
        field: string,
        touched?: boolean | undefined,
        shouldValidate?: boolean | undefined
    ) => Promise<void> | Promise<FormikErrors<IPhone>>;
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean | undefined
    ) => Promise<void> | Promise<FormikErrors<IPhone>>;
    setError: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const ComponentSignInTel = memo((props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //page variable
    const { themes } = useSelector(selectMerchant);

    //page props
    const {
        values,
        isSubmitting,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        errorPhone,
        setError,
    } = props;

    return (
        <form onSubmit={handleSubmit}>
            <ModulesTelInput
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                value={values.phoneNumber || ""}
                errorPhone={errorPhone}
                setError={setError}
            />
            <StyledSharedButton
                size="large"
                bg_color={themes?.themeColor!}
                disabled={isSubmitting}
                type="submit"
            >
                {t("page.sign_in")}
            </StyledSharedButton>
        </form>
    );
});

const StyledSharedButton = styled(SharedButton)`
    margin-top: 15px;
    border-radius: 6px;
`;
